import React, { useState, useCallback, useRef } from 'react';
import styled from 'styled-components/macro';
import DropdownElecciones from './DropdownElecciones'
import { responsive } from '../../../resources/constantes.json';
import { useIsDesktopReal } from '../../../hooks/useMediaQuery.js';

const HeaderTitle = ({ title, subtitle, color = '#D8DFEA', marginBottom = '8rem', withDropdown = true, withColorBar = true }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const isDesktop = useIsDesktopReal();

  const handleBlur = useCallback(
    (e) => {
      const currentTarget = e.currentTarget;

      // Give browser time to focus the next element
      requestAnimationFrame(() => {
        // Check if the new focused element is a child of the original container
        if (!currentTarget.contains(document.activeElement)) {
          setIsOpen(false);
        }
      });
    },
    []
  );

  return <HeaderTitleContainer ref={containerRef} marginBottom={marginBottom} onBlur={handleBlur}>
    {withColorBar &&
      <BarColor color={color} />
    }
    <DataContainer>
      {withDropdown && !isDesktop
        ?
        <DropdownElecciones isOpen={isOpen} setIsOpen={setIsOpen} title={<Title>{title}</Title>} />
        :
        <>
          <Title>{title}</Title>
        </>
      }
      {subtitle && <SubTitle>{subtitle}</SubTitle>}
    </DataContainer>
  </HeaderTitleContainer>
}



const HeaderTitleContainer = styled.div`
  height: 100%;
  display: flex;
  gap:  2.4rem;
  width: fit-content;
  color: #164192;
  justify-content: center;
  align-items: center;
  margin-bottom: ${({ marginBottom }) => marginBottom};

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    gap:  1.4rem;
  }

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    gap:  0.8rem;
  }
`;

const BarColor = styled.div`
  width: 2rem;
  height: 94px;
  flex-shrink: 0;
  background: ${({ color }) => color};

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    width: 8px;
    height: 36px;
  }

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    width: 6px;
    height: 36px;
  }

`;

const DataContainer = styled.div`
  padding: 0.8rem 0 0.4rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    gap: 0.8rem;
  }

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    gap: 0.5rem;
  }
`;

const Title = styled.h1`
  font-size: 3rem;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;

  @media (max-width: ${responsive.maxWidth.desktop}px) {
    font-size: 1.6rem;
  }

`;


const SubTitle = styled.h2`
  font-size: 2.6rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  @media (max-width: ${responsive.maxWidth.desktop}px) {
    font-size: 1.4rem;
  }

`;
export default HeaderTitle;
